<div style="overflow-wrap: break-word;">
  <b style="color: white;">Validation details</b>
  <br />

  <ul >
    <li *ngFor="let message of validationMessages">{{message}}</li>
  </ul>
</div>
